import FilterAccordion from "./FilterAccordion";

const RadioGroup = ({ title, name, options, selectedValue, onChange }) => {
  return (
    <FilterAccordion title={title}>
      <div className="space-y-2">
        {options?.map((opt, idx) => (
          <div key={opt.value} className="flex items-center">
            <input
              id={`${name}-${idx}`}
              name={name}
              type="radio"
              value={opt?.value}
              checked={selectedValue === opt?.value}
              onChange={(e) => onChange(e.target.value)}
              className="h-3.5 w-3.5 border-stone-300 text-brand focus:ring-brand"
            />
            <label
              htmlFor={`${name}-${idx}`}
              className="ml-2.5 font-sans text-[14px] leading-5 font-light text-[#333333]"
            >
              {opt?.label}
            </label>
          </div>
        ))}
      </div>
    </FilterAccordion>
  );
};

export default RadioGroup;
